import styled from "styled-components";

export const Login = styled.div`
  min-height: 100svh;
`

export const LoginImageWrapper = styled.div`
  position: absolute;
  width: 50%;
  min-height: 100svh;
  right: 0;
  top: 0;
  display: none;

  ${({ theme }) => theme.mediaQuery.lg(`
    display: block;
  `)}

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const LoginForm = styled.div`
  padding: ${({ theme }) => theme.rem(32)};

  ${({ theme }) => theme.mediaQuery.md(`
    padding: ${theme.rem(64)};
  `)}
`

export const LoginFormRegister = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.rem(8)};
  align-items: center;
`

export const LoginFormRegisterCTA = styled.div`
  text-decoration: underline;
  cursor: pointer;
`

export const LoginFormResetPassword = styled.div`
  text-align: center;
`

export const LoginFormInputWrapper = styled.div``

export const LoginFormIcon = styled.div`
  i {
    font-size: ${({ theme }) => theme.rem(24)};
  }
`

export const LoginFormLogoWrapper = styled.div``

